import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import'./me.css'
import kate from"../../images/projectimages/katernew.png"
// import Zoom from 'react-reveal/Zoom';

function Me(){
    const ref = useRef(null);
    const isInView = useInView(ref, { once: true, margin: "-100px" });

    return(
      <motion.div
        ref={ref}
        className="about_container"
        id="about-me"
        initial={{ opacity: 0, y: 50 }}
        animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
      >
        <div className="about_content">
          <div>
        <img src={kate} alt="Katelin Reilly" loading="lazy"/>
          </div>
           <p>
I'm a Customer Success and Account leader who's accountable to one thing above all: results. At Spoke, I scaled customer accounts by <span className="skills">200%+, grew my book from 4 to 19 accounts, and was promoted to Head of Accounts in under a year</span> — where I owned every client relationship, built the team, and stood up the operational systems that kept growth and retention on track.
<br/><br/>
What sets me apart is technical and product fluency most CS professionals don't have. I came up through software development, studied UX/UI at George Washington University, and I design in Figma and build in React and Python. That means I understand the product as deeply as the customer using it — so I can <span className="skills">translate between customers, business goals, and engineering without losing the thread</span>.
<br/><br/>
I've sat with clients to understand what's actually broken, seen the UX problem and the technical constraint at the same time, and turned that into solutions that move real metrics. A global perspective from traveling to 20+ countries across six continents shapes how I work, but my focus never changes: <span className="skills">building connections between people, systems, and ideas that hold up in the real world</span>.
</p>
        </div>
        <div className="pull-quote">
  "I don't just manage accounts — I understand the product well enough to solve what's actually broken."
</div>
            {/* </Zoom>  */}
          </motion.div>
          
    
    )
}
export default Me